export const homeContent = `
  <h1>Take some time, look around.</h1>
  <br />
  <p>I created this subdomain to store summaries for myself.<br>
  My resume can be found in the main site <a href="https://www.autumn8.be"><b>here</b></a>.<br><br>
  If you have any questions or remarks, please mail them to me at
  <a href="mailto:contact@autumn8.be">contact@autumn8.be</a></p>

  <div id="activities">
    <h2>My Github activity</h2>
    <div id="github-calendar">
    </div>
  </div>
  `;
